<syslink-grid
    #gridComponent
    [canView]="canView"
    [canSearch]="canSearch"
    [canRefresh]="canRefresh"
    [canAdd]="canAdd"
    [canSort]="canSort"
    [canUpdate]="canUpdate"
    [canDelete]="canDelete"
    [canFilter]="canFilter"
    [canExport]="canExport"
    [canDblClck]="canDblClck"
    [items]="items"
    [columns]="columns"
    (add)="add.emit()"
    [storageKey]="storageKey"
    (doubleClick)="rowDoubleClicked.emit($event)"
    exportFileName="Products stock move"
></syslink-grid>

